module.exports = __webpack_public_path__ + "img/D202107_3.e7852b03.gif";